module.exports = __webpack_public_path__ + "static/mopz-casebg@2x-min-a9648cb3d1e9ccf1656bbd49dd274c66.jpg";